/**
 * What a `partyNotice` is about (ADR-101 decision 19): a closed set, a kind the page does not know draws nothing. `flag` goes
 * to a member whose seat was freed because its preference was not the party's flag (ADR-076's amendment of 2026-10-08, E7),
 * about itself.
 */
export const PARTY_NOTICE_KINDS = ["joined", "left", "removed", "leader", "granted", "revoked", "declined", "expired", "withdrawn", "offline", "online", "ended", "flag"] as const;
export type PartyNoticeKind = (typeof PARTY_NOTICE_KINDS)[number];

/**
 * Why a party request changed nothing (ADR-101 decision 19), a closed set: `rate`, `recent` and `busy` carry a wait,
 * `absent` is a remove, promote or grant naming no member of this party, and `alone` a leave or a party line from a
 * character in no party. `flag` is an accept whose preference differs from the party's flag and `level` an accept to a Flagged
 * party below the rules' `pvp_level` (ADR-076's amendment of 2026-10-08, E3); both leave the invite pending.
 */
export const PARTY_REFUSALS = ["rate", "recent", "busy", "muted", "leader", "cannot", "self", "member", "full", "pending", "combat", "absent", "offline", "alone", "gone", "unavailable", "flag", "level"] as const;
export type PartyRefusal = (typeof PARTY_REFUSALS)[number];
